import { combineReducers } from 'redux';

import type { AddonManagementFormState } from '.';
import { filtersReducer } from './filters/filters.reducer';
import { infosReducer } from './infos/infos.reducer';
import { metaDataReducer } from './metaData/fields';
import { quoteDetailsReducer } from './quoteDetails/quoteDetails.reducer';

export const addonManagementFormReducer = combineReducers<AddonManagementFormState>({
  infos: infosReducer,
  quoteDetails: quoteDetailsReducer,
  metaData: metaDataReducer,
  filter: filtersReducer,
});
